import React from "react" 
import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addRecord } from "service/api"

const defaultValue = {
     record: "", 
    color: ""
}

const Addrecord = () => {
  const [category, setCategory] = useState(defaultValue);
  const [errors, setErrors] = useState({});
   const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

   useEffect(() => {
            document.title = "Record Category | Add Record Category";
          }, []);

  const onValueChange = (e) => {
    setCategory({ ...category, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error on typing
  };

  const validate = () => {
    const formErrors = {};
    if (!category.record.trim()) {
      formErrors.record = "Record Category is required";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddRecord = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true); // ✅ start loader
    try {
      await addRecord(category);
      toast.success("Record Category saved successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
      navigate("/record");
    } catch (error) {
      toast.error("Failed to save record.");
      console.error(error);
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };

    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Record Category </h4>
            <Link to="/record" className="btn btn-danger">Record List</Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Record Category<span style={{ color: "red" }}>*</span></Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.record ? "is-invalid" : ""}`}
                          name="record"
                          Placeholder="Enter Record Category"
                          onChange={e => onValueChange(e)}
                        />
                        {errors.record && (
                          <div className="invalid-feedback">{errors.record}</div>
                        )}
                      </div>
                    </Col>
                    {/* <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Color
                        </Label>
                        <Input
                          type="color"
                          className="form-control"
                          name="color"
                          onChange={e => onValueChange(e)}
                        />
                      </div>
                    </Col> */}
                  </Row>
                  <div>
                    <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddRecord}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  Addrecord ;
